import React from "react";
import styled from "styled-components";
import Modal from "components/ui/Modal";
import Button from "./Button";
import { combineObject } from "utils/object";

export const Alert = (message, option) => {
  option = combineObject(
    {
      title: "",
      button: {
        name: "확인",
        color: "blue",
      },
      callback: undefined,
    },
    option || {},
  );
  const eventHandler = {
    close: () => {
      Modal();
      if (option.callback) option.callback();
    },
  };
  Modal(
    <Wrapper>
      <div className="middle">
        <h4>{option.title}</h4>
        <p dangerouslySetInnerHTML={{ __html: message }}></p>
      </div>
      <div className="bottom">
        <Button
          outline
          color={option.button.color}
          onClick={eventHandler.close}
        >
          {option.button.name}
        </Button>
      </div>
    </Wrapper>,
  );
};

const Wrapper = styled.div`
  & {
    max-width: 320px;
  }
  .middle {
    padding: 25px !important;
  }
  .middle h4 {
    text-align: center;
    font-weight: bold;
  }
  .middle p {
    text-align: center;
    font-weight: 600;
  }
  .bottom {
    padding: 0 !important;
  }
  .bottom button {
    width: 100% !important;
    font-weight: 700;
  }
  .bottom button + button {
    border-left: 1px solid var(--border) !important;
  }
`;

export default Alert;
